<nav class="parser-nav" [attr.aria-label]="'AI_PARSER_TITLE' | translate">
  <a
    class="parser-nav-tab"
    routerLink="/order-parser"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    {{ 'AI_PARSER_TITLE' | translate }}
    <span *ngIf="needsReview$ | async as count" class="parser-nav-badge">{{ count }}</span>
  </a>
  <a class="parser-nav-tab" routerLink="/order-parser/configs" routerLinkActive="active">
    {{ 'AI_PARSER_CONFIGS_TITLE' | translate }}
  </a>
  <a
    *ngIf="isAdmin$ | async"
    class="parser-nav-tab"
    routerLink="/order-parser/settings"
    routerLinkActive="active"
  >
    {{ 'AI_PARSER_SETTINGS_TITLE' | translate }}
  </a>
</nav>
